import React__default from 'react';
import { YouMayAlsoLikeArticles } from './components/you-may-also-like-articles.esm.js';
import { YouMayAlsoLikeHeader } from './components/you-may-also-like-header.esm.js';

var YouMayAlsoLike = function YouMayAlsoLike(props) {
  var articleClickHandler = props.articleClickHandler,
    articles = props.articles,
    messages = props.messages;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "csg-tw- flex grow flex-col border-t px-0.5 py-2",
    "automation-id": "YouMayAlsoLike"
  }, /*#__PURE__*/React__default.createElement(YouMayAlsoLikeHeader, {
    header: messages.header
  }), /*#__PURE__*/React__default.createElement(YouMayAlsoLikeArticles, {
    articles: articles,
    articleClickHandler: articleClickHandler
  }));
};

export { YouMayAlsoLike };
//# sourceMappingURL=you-may-also-like.esm.js.map
